import React from "react";
import * as S from "@styled";
import * as AppPath from "./model/AppPath";
import { ThemeProvider } from "styled-components";
import { Switch, Route, Redirect } from "react-router-dom"
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { PageLoadSpinner } from "shared/components/PageLoadSpinner";

import { ProcessTemplateAppReducerState } from "./model/AppState";
import { processTemplateInitialState, processTemplateAppReducer } from "./reducers/AppReducer";

import List from "./components/List";
import EditModeModal from "./components/modals/EditModeModal";
// import ImportModal from "./components/modals/ImportModal";
// import ConfirmProcessUpdatesModal from "./components/modals/ConfirmProcessUpdatesModal";
import CreateModal from "./components/modals/CreateModal";
import ChangeLogModal from "./components/modals/ChangeLogModal";
import UsedInModal from "./components/modals/UsedInModal";
//import SwitchVersionModal from "./components/modals/SwitchVersionModal";
import DeleteModal from "./components/modals/DeleteModal";
import TagModal from "./components/modals/TagModal";

export const AppContext = React.createContext<ProcessTemplateAppReducerState>({
    state: processTemplateInitialState,
    dispatch: () => null,
});

const App: React.FC = () => {
    const [state, dispatch] = React.useReducer(processTemplateAppReducer, processTemplateInitialState);
    const [theme] = useUserTheme();

    const searchParams = location.search || "";
    const redirectTarget = `${AppPath.processTemplateURLBase}/Default/Default${searchParams}`;

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <ThemeProvider theme={{ mode: theme }}>
                <Switch>
                    <Redirect exact={true} from={AppPath.processTemplateURLBase} to={redirectTarget} />
                    <Route exact={true} path={`${AppPath.processTemplateURLBase}/:environmentName/:agentGroupName`}>
                        <S.IndentedContainer>
                            <S.RelativePageHeaderContainer>
                                <h1>Templates</h1>
                            </S.RelativePageHeaderContainer>

                            <List />
                        </S.IndentedContainer>

                        {/* TODO: Wrap modals in their own routes */}
                        <EditModeModal />
                        {/* <ImportModal />  */}
                        {/* <ConfirmProcessUpdatesModal /> */}
                        <CreateModal />
                        <ChangeLogModal />
                        <UsedInModal />
                        {/* <SwitchVersionModal /> */}
                        <DeleteModal />
                        <TagModal />

                        {state.loading && (
                            <PageLoadSpinner />
                        )}
                    </Route>
                </Switch>
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;